import { AnalysisIssueAssignment, IssueSeverityEnum } from '@hefe/models';

type AssignmentRole = AnalysisIssueAssignment['role'];

export const roleLabels: Record<AssignmentRole, string> = {
  player: 'Spieler',
  coach: 'Trainer',
  task: 'Aufgabe',
  target: 'Ziel',
  support: 'Unterstützung',
  related: 'Verwandt',
};

export const severityLabels: Record<IssueSeverityEnum, string> = {
  error: 'Fehler',
  warning: 'Warnung',
  info: 'Hinweis',
};

export const severityColors: Record<IssueSeverityEnum, string> = {
  error: 'error',
  warning: 'warning',
  info: 'processing',
};

export function formatGroupId(groupId: string | null): string | null {
  if (!groupId) {
    return null;
  }

  return groupId.replace('basketball_team:', 'Team ');
}
